import React, { useEffect, useState } from "react";
import { Button } from "antd";
import SisLoader from "../../../../../widgets/loader";
import { ErrorToast, SuccessToast } from "../../../../../widgets/AppToast";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import FramoTable from "../../components/CargoCraneCom/FramoRow";
import AddFramoDetailsModal from "../../components/CargoCraneCom/AddFramoDetailsModal";

function Framo({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [responseData, setResponseData] = useState({});
  const [errors, set_errors] = useState({});

  const listFramoData = () => {
    const formData = new FormData();
    formData.append("ship_id", id);
    try {
      post(ApiURL.list_framo_details, formData).then((res) => {
        if (res?.status === true) {
          setFilteredData(res?.framo_parameters_data || []);
        }
      });
    } catch (error) {
      console.error("Error fetching Framo list:", error);
    }
  };

  useEffect(() => {
    listFramoData();
  }, []);

  const addFramoData = (data) => {
    set_loader(true);
    try {
      const formData = new FormData();
      formData.append("ship_id", id);
      formData.append("framo_name", data?.framo_name);
      formData.append("framo_maker", data?.framo_maker);
      formData.append("framo_model", data?.framo_model);
      // formData.append("section", data?.section);
      formData.append("selected_parameters", JSON.stringify(data?.selectedParams));
      formData.append("other_parameters", JSON.stringify(data?.customParams));

      post(ApiURL.add_framo_details, formData).then((res) => {
        if (res?.status === true) {
          SuccessToast("Framo Details Saved!", "Framo Details Successfully Added!");
          listFramoData();
          setIsModalOpen(false);
          if (onSuccess) onSuccess();
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
        set_loader(false);
      });
    } catch (error) {
      console.error("Error occurred while adding Framo details:", error);
      set_loader(false);
    }
  };

  const updateFramoData = (data) => {
    set_loader(true);
    try {
      const formData = new FormData();
      formData.append("id", data?.id);
      formData.append("ship_id", id);
      formData.append("framo_name", data?.framo_name);
      formData.append("framo_maker", data?.framo_maker);
      formData.append("framo_model", data?.framo_model);
      // formData.append("section", data?.section);
      formData.append("selected_parameters", JSON.stringify(data?.selectedParams));
      formData.append("other_parameters", JSON.stringify(data?.customParams));

      post(ApiURL.update_view_framo_details, formData).then((res) => {
        if (res?.status === true) {
          SuccessToast("Success", res?.message || "Framo Details Updated Successfully!");
          setIsModalOpen(false);
          listFramoData();
          if (onSuccess) onSuccess();
          set_errors({});
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
        set_loader(false);
      });
    } catch (error) {
      console.error("Error occurred while updating Framo details:", error);
      set_loader(false);
    }
  };

  const viewFramoData = (row) => {
    const formData = new FormData();
    formData.append("ship_id", id);
    formData.append("id", row?.id);
    formData.append("request_type", "view");
    try {
      post(ApiURL.update_view_framo_details, formData).then((res) => {
        if (res?.status === true) {
          setResponseData(res?.framo_parameters_data || {});
          setIsModalOpen(true);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } catch (error) {
      console.error("Error viewing Framo details:", error);
    }
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <h3 style={{ marginTop: "15px", marginBottom: "15px" }}>Framo Information</h3>
        <Button
          type="primary"
          onClick={() => setIsModalOpen(true)}
          style={{ position: "absolute", right: "0px", top: "-10px" }}
        >
          Add Framo
        </Button>

        <AddFramoDetailsModal
          visible={isModalOpen}
          onOk={(data) => {
            if (responseData?.id) {
              updateFramoData({ ...data, id: responseData.id });
            } else {
              addFramoData(data);
            }
          }}
          onCancel={() => {
            setIsModalOpen(false);
            setResponseData({});
            set_errors({});
          }}
          responseData={responseData}
          errors={errors}
        />

        {loader ? (
          <SisLoader />
        ) : (
          <>
            {filteredData?.length > 0 ? (
              <FramoTable data={filteredData} onEdit={viewFramoData} />
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
}

export default Framo;
